import {FC} from 'react'
import {uploadTemplateGuestService} from '../../../../services/guest.service'
import {ShowSnackBar} from '../../../../../../util/functions'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../util/Constants'
import {MasiveUploadHoteleria} from '../../../../../../components/UI/Form/MasiveHoteleria'
import {getTemplateGuestsService} from '../../services'

const FormMasiveUploadGuest: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const data = await uploadTemplateGuestService(formData) // Use the service to upload the file
      return data
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }

  return (
    <MasiveUploadHoteleria
      serviceTemplate={getTemplateGuestsService}
      handleSendService={handleUpload}
      showModalList
      title='Huespedes'
    />
  )
}

export {FormMasiveUploadGuest}
